<template>
  <div class="DataCenter">
    <div class="DataCenter_body">
      <div class="DataCenter_head">
        <span style="margin-right: 10px">项目:</span>
        <el-select v-model="ProjectValue" placeholder="请选择" @change="ProjectChange">
          <el-option v-for="(item, index) in Project" :key="index" :label="item.Name" :value="item.Id"></el-option>
        </el-select>
        <span style="margin-right: 10px; margin-left: 10px">问卷:</span>
        <el-select v-model="Questionnairevalue" placeholder="请选择" @change="changeItem">
          <el-option v-for="(item, index) in CRFSurface" :key="index" :label="item.questionnaireName" :value="item.Id"></el-option>
        </el-select>
        <el-button @click="QuestionnaireQuery" type="primary" icon="el-icon-search" style="margin-left: 10px">查询</el-button>
        <el-button type="primary" @click="CollectedExport">
          <i class="el-icon-download"></i>
          导出
        </el-button>
        <el-button @click="DeleteQuery" type="primary">
          <i class="el-icon-delete"></i>
          删除
        </el-button>
      </div>
      <div class="DataCenter_middle content">
        <el-table border :data="tableData" height="96%" style="width: 100%; height: 630px" :header-cell-style="{ background: 'rgb(240, 247, 253)' }" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column v-if="admin == '00000000-0000-0000-0000-000000000000'" prop="OrganizationName" label="组织名称" min-width="80" align="center"></el-table-column>
          <el-table-column align="center" prop="Frq" :sortable="true" :sort-method="sortByFrq" label="访视次数">
            <template slot-scope="scope">
              <p>{{ scope.row.Frq == 0 ? '基线' : scope.row.Frq }}</p>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="QuestionnaireName" label="问卷名称" :sortable="true" :sort-method="sortByQuestionnaireName" width="480"></el-table-column>
          <el-table-column align="center" prop="StatusName" label="问卷状态" width="180"></el-table-column>
          <el-table-column align="center" prop="TargetName" :sortable="true" :sort-method="sortByName" label="患者姓名"></el-table-column>
          <el-table-column align="center" prop="TargetTel" label="患者电话"></el-table-column>
          <el-table-column label="填写时间" :sortable="true" :sort-method="sortByCreateTime" align="center">
            <template slot-scope="scope">{{ scope.row.EndTime ? scope.row.EndTime : scope.row.BeginTime }}</template>
          </el-table-column>
          <el-table-column label="完成度" align="center">
            <template #default="{ row }">
              {{ row.topicNum ? ((row.fillTopicNum / row.topicNum) * 100).toFixed(1) + '%' : '0%' }}
            </template>
          </el-table-column>
          <el-table-column label="是否同步问卷" align="center">
            <template #default="{ row }">
              {{ row.CollectedQuestionnaireState?.trim() == 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
              <el-link @click="ViewQuestionnaire(scope.row)" :underline="false" style="margin-right: 3px">
                <i class="el-icon-zoom-in"></i>
                查看/修改
              </el-link>
              <el-link @click="analysis(scope.row)" :underline="false">
                <i class="el-icon-zoom-in"></i>
                数据分析
              </el-link>
              <!-- <el-link @click="ModifyQuestionnaire(scope.row)"><i class="el-icon-zoom-in"></i>修改</el-link> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.rows" @pagination="CollectedQuestionnaire"></Pagination>
    </div>
    <div>
      <el-dialog :visible.sync="dialogVisible" fullscreen>
        <div>
          <iframe v-if="Url != ''" :src="Url" frameborder="0" width="100%" height="880px" ref="myFrame"></iframe>
          <div v-if="dataRow && dataRow.VoiceFile" style="position: absolute; top: 10%; right: 10%">
            <audio :src="dataRow.VoiceFile" controls preload="auto"></audio>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 数据分析表格dialog -->
    <div class="x">
      <el-dialog :visible.sync="fxDialog" width="80%">
        <div slot="title" class="header-title">
          <span class="title-name"></span>
          <span class="title-age">数据分析</span>
        </div>
        <div style="margin-bottom: 20px" class="div_select">
          <el-table border :data="fxTableData" style="width: 100%; height: 80%" :header-cell-style="{ background: 'rgb(240, 247, 253)' }">
            <el-table-column :sortable="true" :sort-method="sortByFrq1" align="center" prop="score" label="数据得分"></el-table-column>
            <el-table-column align="center" prop="pf" label="配方"></el-table-column>
            <el-table-column align="center" prop="scl" label="首次量"></el-table-column>
            <el-table-column align="center" prop="cxl" label="持续量"></el-table-column>
            <el-table-column align="center" prop="dcl" label="单次量"></el-table-column>
            <el-table-column align="center" prop="sdsj" label="锁定时间"></el-table-column>
            <el-table-column align="center" prop="jxl" label="极限量"></el-table-column>
            <el-table-column align="center" prop="ks" label="输液开始时间"></el-table-column>
            <el-table-column align="center" prop="js" label="输液结束时间"></el-table-column>
            <el-table-column align="center" prop="sjc" label="时间差(min)"></el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Diagnosis } from '../../api/DataMapping.js';
import PatientCenter from '../../api/PatientCenter';
import derive from '../../api/derive';
import questionnaire from '../../api/questionnaire';
import Pagination from '../../components/Pagination/index.vue';
import { local } from '../../utils/storage';
export default {
  directives: {
    'el-select-loadmore': {
      bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  },
  data() {
    return {
      QueryType: null,
      ProjectId: null,
      ProjectQuestionnaireId: null,
      ProjectPatientId: null,

      fxTableData: [],
      fxDialog: false,
      admin: local.get('UserId'),
      Url: '',
      dialogVisible: false,
      activeName: 'first',
      Project: [],
      CRFSurface: [],
      PatientTable: [],
      ProjectValue: '',
      Questionnairevalue: '',
      PatientValue: '',
      tableData: [],
      total: 0,
      listQuery: {
        Key: '',
        page: 1,
        rows: 10
      },
      multipleSelection: [],
      //保存row数据
      dataRow: {}
    };
  },
  components: {
    Pagination
  },
  created() {
    this.ProjectList();
    this.ProjectChange('all');
  },
  methods: {
    changeItem() {
      this.listQuery = {
        Key: '',
        page: 1,
        rows: 10
      };
    },
    //远程搜索
    remoteMethod(name) {
      // PatientCenter.GetPageListData();
    },
    loadmore() {
      let params = {
        key: '',
        page: 1,
        rows: 10
      };
    },
    //通过文字进行排序
    sortByQuestionnaireName(obj1, obj2) {
      if ([obj1.QuestionnaireName, obj2.QuestionnaireName][0] == [obj1.QuestionnaireName, obj2.QuestionnaireName].sort((a, b) => a.localeCompare(b, 'zh', { sensitivity: 'accent' }))[0]) {
        return -1;
      } else {
        return 1;
      }
    },
    //数字文字排序
    sortByFrq(obj1, obj2) {
      if (
        [obj1.Frq, obj2.Frq][0] ==
        [obj1.Frq, obj2.Frq].sort((a, b) => {
          var c = isFinite(a),
            d = isFinite(b);
          return (c != d && d - c) || (c && d ? a - b : a.localeCompare(b, 'zh', { sensitivity: 'accent' }));
        })[0]
      ) {
        return -1;
      } else {
        return 1;
      }
    },
    sortByFrq1(obj1, obj2) {
      if (
        [obj1.Frq, obj2.Frq][0] ==
        [obj1.Frq, obj2.Frq].sort((a, b) => {
          var c = isFinite(a),
            d = isFinite(b);
          return (c != d && d - c) || (c && d ? a - b : a.localeCompare(b, 'zh', { sensitivity: 'accent' }));
        })[0]
      ) {
        return 1;
      } else {
        return -1;
      }
    },
    sortByName(obj1, obj2) {
      if ([obj1.TargetName, obj2.TargetName][0] == [obj1.TargetName, obj2.TargetName].sort((a, b) => a.localeCompare(b, 'zh', { sensitivity: 'accent' }))[0]) {
        return -1;
      } else {
        return 1;
      }
    },
    sortByCreateTime(obj1, obj2) {},
    DeleteQuery() {
      if (this.multipleSelection.length == 0) {
        // this.$message({
        //   type:' info',
        //   message:'请先选择需要删除的问卷！'
        // });
        alert('请先勾选需要删除的问卷！');
        return;
      }
      let parameter = [];
      this.multipleSelection.forEach(item => {
        parameter.push(item.Id);
      });
      this.$confirm('你确定要删除这些数据吗? 删除后无法恢复,请谨慎操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          derive.DeleteFollowUpRecordsData(parameter).then(res => {
            if (res.data.Status == 1) {
              this.ProjectList();
              this.$message({
                type: 'success',
                message: res.data.Message
              });
            } else {
              this.$message({
                type: 'error',
                message: res.data.Message
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    downloadAudioStream(data, name) {
      // ArrayBuffer 转为 Blob
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' });
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style.display = 'none';
      a.setAttribute('href', objectUrl);
      a.setAttribute('target', '_blank');
      a.setAttribute('download', name + '.' + 'xls');
      a.click();
      URL.revokeObjectURL(objectUrl);
      document.body.removeChild(a);
    },
    CollectedExport() {
      const Parameter = {
        QueryType: '01',
        ProjectId: this.ProjectValue,
        ProjectQuestionnaireId: this.Questionnairevalue
      };
      derive.CollectedExportData(Parameter).then(res => {
        this.downloadAudioStream(res.data, '数据导出');
      });
    },
    PatientExport() {
      const Parameter = {
        QueryType: '00',
        ProjectId: this.ProjectValue,
        // ProjectPatientId:this.PatientValue
        Key: this.PatientValue
      };
      derive.CollectedExportData(Parameter).then(res => {
        this.downloadAudioStream(res.data, '数据导出');
      });
    },
    async ProjectList() {
      derive.ProjectListData().then(res => {
        if (res.data.Status == 1) {
          this.Project = res.data.Data;
          this.Project.unshift({ Name: '全部', Id: 'all' });
          this.ProjectValue = 'all';
          this.CollectedQuestionnaire('01', this.ProjectValue, '', '');
        } else {
          alert(res.data.Message);
        }
      });
    },
    CollectedQuestionnaire(QueryType, ProjectId, ProjectQuestionnaireId, ProjectPatientId, PatientValue) {
      if (QueryType) {
        this.QueryType = QueryType;
      }
      if (ProjectId) {
        this.ProjectId = ProjectId;
      }
      if (ProjectQuestionnaireId) {
        this.ProjectQuestionnaireId = ProjectQuestionnaireId;
      }
      if (ProjectPatientId) {
        this.ProjectPatientId = ProjectPatientId;
      }
      if (PatientValue) {
        this.PatientValue = PatientValue;
      }

      const Parameter = {
        Key: this.PatientValue,
        page: this.listQuery.page,
        rows: this.listQuery.rows,
        QueryType: this.QueryType,
        ProjectId: this.ProjectId,
        ProjectQuestionnaireId: this.ProjectQuestionnaireId,
        ProjectPatientId: this.ProjectPatientId
      };
      questionnaire.CollectedQuestionnaireData(Parameter).then(res => {
        if (res.data.Status == 1) {
          this.total = res.data.Data.total;
          this.tableData = res.data.Data.rows;
        } else {
          alert(res.data.Message);
        }
      });
    },
    //问卷查出已收集问卷列表
    QuestionnaireQuery() {
      this.CollectedQuestionnaire('01', this.ProjectValue, this.Questionnairevalue);
    },
    //患者查出已收集问卷列表
    PatientQuery() {
      this.CollectedQuestionnaire('00', this.ProjectValue, '', '', this.PatientValue);
    },
    //患者列表change
    PatientChange(e) {},
    //项目查出问卷列表,患者列表
    ProjectChange(e) {
      this.Questionnairevalue = '';
      this.PatientValue = '';
      const ParameterProject = {
        ProjectId: e
      };
      derive.CRFSurfaceData(ParameterProject).then(res => {
        if (res.data.Status == 1) {
          this.CRFSurface = res.data.Data;
        } else {
          alert(res.data.Message);
        }
      });
      const ParameterPatient = {
        projectId: e
      };
      PatientCenter.NothingGetPageListData(ParameterPatient).then(res => {
        if (res.data.Status == 1) {
          this.PatientTable = res.data.Data;
        } else {
          alert(res.data.Message);
        }
      });
    },
    //查看问卷
    ViewQuestionnaire(row) {
      this.Url = '';
      this.dataRow = row;
      this.dialogVisible = true;
      this.Url = `${window.global_config.BASE_URL1}/#/PcIframe?qid=${row.CollectedQuestionnaireId}&type=5&r=${Math.random() * 10}`;
      this.Url = 'about:blank';
      setTimeout(() => {
        this.Url = `${window.global_config.BASE_URL1}/#/PcIframe?qid=${row.CollectedQuestionnaireId}&type=5&r=${Math.random() * 10}`;
      }, 300);
    },
    //数据分析
    analysis(row) {
      const dbObj = {
        配方: 'pf',
        首次量: 'scl',
        持续量: 'cxl',
        单次量: 'dcl',
        锁定时间: 'sdsj',
        极限量: 'jxl',
        输液开始时间: 'ks',
        输液结束时间: 'js',
        时间差: 'sjc'
      };
      Diagnosis(row.ProjectQuestionnaireId, row.CollectedQuestionnaireId).then(res => {
        const mergedData = res.data.map(item => {
          return {
            score: item.score,
            ...item.prescription
          };
        });

        function replaceKeys(arr, dbObj) {
          const result = arr.map(obj => {
            const newObj = {};
            for (const key in obj) {
              if (dbObj.hasOwnProperty(key)) {
                newObj[dbObj[key]] = obj[key];
              } else {
                newObj[key] = obj[key];
              }
            }
            return newObj;
          });
          return result;
        }
        const newArr = replaceKeys(mergedData, dbObj);
        this.fxTableData = newArr;
        console.log(this.fxTableData);
      });
      this.fxDialog = true;
      console.log(row);
    }
    //修改问卷
    // ModifyQuestionnaire(row){
    //   console.log(row);
    // }
  }
};
</script>
<style lang="scss" scoped>
.DataCenter_head {
  /deep/.el-input {
    width: 300px;
  }
}
/deep/.el-tabs__item {
  font-size: 18px;
}
/deep/.el-dialog .el-dialog__header {
  margin-bottom: 0;
}
/deep/.el-dialog__headerbtn {
  top: 4px;
  font-size: 22px;
}
/deep/.el-dialog__body {
  padding: 0;
}
// /deep/.el-input__inner{
//   height: 30px;
//   line-height: 30px;
// }
// /deep/.el-input__icon{
//   line-height: 30px;
// }
.DataCenter {
  width: 100%;
  height: 100%;
  min-width: 1440px;
  box-sizing: border-box;
  // border-radius: 10px;
  overflow: hidden;
  .DataCenter_body {
    background: #fff;
    display: flex;
    flex-direction: column;
    height: 100%;
    .DataCenter_head {
      margin-bottom: 20px;
      box-sizing: border-box;
      margin-bottom: 20px;
    }
    .DataCenter_middle {
      // height: 630px;
      // padding: 20px;
      box-sizing: border-box;
      margin-bottom: 10px;
      flex: 1;
    }
  }
}

@media screen and (-webkit-min-device-pixel-ratio: 1.5) {
  .DataCenter {
    min-width: 0 !important;

    .DataCenter_head {
      /deep/.el-input--suffix {
        width: 140px;
      }
    }

    .DataCenter_middle {
      margin-bottom: 0 !important;
    }
  }
}
.div_select {
  height: 100%;
  padding: 50px;
  /deep/.el-dialog__body {
    height: 800px;
    overflow: auto;
    padding: 0;
  }
  .el-table {
    overflow: auto;
  }
}
.x {
  /deep/.el-dialog__body {
    height: 680px !important;
  }
}
</style>
